/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  AccessRequestPostRequest,
  AccessRequestsAppAccessRulePatchRequest,
  AccessRequestsAppAccessRulePostRequest,
  GetAccessRequestsAppRulesMe200Response,
  GetAccessRequestsMe200Response,
  PostAccessRequestsMeAccessRuleID201Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    AccessRequestPostRequestFromJSON,
    AccessRequestPostRequestToJSON,
    AccessRequestsAppAccessRulePatchRequestFromJSON,
    AccessRequestsAppAccessRulePatchRequestToJSON,
    AccessRequestsAppAccessRulePostRequestFromJSON,
    AccessRequestsAppAccessRulePostRequestToJSON,
    GetAccessRequestsAppRulesMe200ResponseFromJSON,
    GetAccessRequestsAppRulesMe200ResponseToJSON,
    GetAccessRequestsMe200ResponseFromJSON,
    GetAccessRequestsMe200ResponseToJSON,
    PostAccessRequestsMeAccessRuleID201ResponseFromJSON,
    PostAccessRequestsMeAccessRuleID201ResponseToJSON,
} from '../models';

export interface DeleteAccessRequestsAppRulesRuleIDRequest {
    accessRuleId: string;
    slashIDOrgID: string;
}

export interface GetAccessRequestsAppRulesPersonsPersonIDRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface GetAccessRequestsPersonsPersonIDRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface PatchAccessRequestsAppRulesRuleIDRequest {
    accessRuleId: string;
    slashIDOrgID: string;
    accessRequestsAppAccessRulePatchRequest: AccessRequestsAppAccessRulePatchRequest;
}

export interface PostAccessRequestsAppRulePersonIDRequest {
    personId: string;
    slashIDOrgID: string;
    accessRequestsAppAccessRulePostRequest: AccessRequestsAppAccessRulePostRequest;
}

export interface PostAccessRequestsMeAccessRuleIDRequest {
    accessRuleId: string;
    accessRequestPostRequest: AccessRequestPostRequest;
}

/**
 * 
 */
export class IdentityProtectionApi extends runtime.BaseAPI {

    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */
    async deleteAccessRequestsAppRulesRuleIDRaw(requestParameters: DeleteAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.accessRuleId === null || requestParameters.accessRuleId === undefined) {
            throw new runtime.RequiredError('accessRuleId','Required parameter requestParameters.accessRuleId was null or undefined when calling deleteAccessRequestsAppRulesRuleID.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling deleteAccessRequestsAppRulesRuleID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/app-rules/{access_rule_id}`.replace(`{${"access_rule_id"}}`, encodeURIComponent(String(requestParameters.accessRuleId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */
    async deleteAccessRequestsAppRulesRuleID(requestParameters: DeleteAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */
    async getAccessRequestsAppRulesMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsAppRulesMe200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/app-rules/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsAppRulesMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */
    async getAccessRequestsAppRulesMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsAppRulesMe200Response> {
        const response = await this.getAccessRequestsAppRulesMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */
    async getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters: GetAccessRequestsAppRulesPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsAppRulesMe200Response>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/app-rules/persons/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsAppRulesMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */
    async getAccessRequestsAppRulesPersonsPersonID(requestParameters: GetAccessRequestsAppRulesPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsAppRulesMe200Response> {
        const response = await this.getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */
    async getAccessRequestsMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsMe200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */
    async getAccessRequestsMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsMe200Response> {
        const response = await this.getAccessRequestsMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */
    async getAccessRequestsPersonsPersonIDRaw(requestParameters: GetAccessRequestsPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsMe200Response>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getAccessRequestsPersonsPersonID.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getAccessRequestsPersonsPersonID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/persons/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */
    async getAccessRequestsPersonsPersonID(requestParameters: GetAccessRequestsPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsMe200Response> {
        const response = await this.getAccessRequestsPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */
    async patchAccessRequestsAppRulesRuleIDRaw(requestParameters: PatchAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.accessRuleId === null || requestParameters.accessRuleId === undefined) {
            throw new runtime.RequiredError('accessRuleId','Required parameter requestParameters.accessRuleId was null or undefined when calling patchAccessRequestsAppRulesRuleID.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling patchAccessRequestsAppRulesRuleID.');
        }

        if (requestParameters.accessRequestsAppAccessRulePatchRequest === null || requestParameters.accessRequestsAppAccessRulePatchRequest === undefined) {
            throw new runtime.RequiredError('accessRequestsAppAccessRulePatchRequest','Required parameter requestParameters.accessRequestsAppAccessRulePatchRequest was null or undefined when calling patchAccessRequestsAppRulesRuleID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/app-rules/{access_rule_id}`.replace(`{${"access_rule_id"}}`, encodeURIComponent(String(requestParameters.accessRuleId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestsAppAccessRulePatchRequestToJSON(requestParameters.accessRequestsAppAccessRulePatchRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */
    async patchAccessRequestsAppRulesRuleID(requestParameters: PatchAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */
    async postAccessRequestsAppRulePersonIDRaw(requestParameters: PostAccessRequestsAppRulePersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAccessRequestsMeAccessRuleID201Response>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling postAccessRequestsAppRulePersonID.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postAccessRequestsAppRulePersonID.');
        }

        if (requestParameters.accessRequestsAppAccessRulePostRequest === null || requestParameters.accessRequestsAppAccessRulePostRequest === undefined) {
            throw new runtime.RequiredError('accessRequestsAppAccessRulePostRequest','Required parameter requestParameters.accessRequestsAppAccessRulePostRequest was null or undefined when calling postAccessRequestsAppRulePersonID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/app-rules/persons/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestsAppAccessRulePostRequestToJSON(requestParameters.accessRequestsAppAccessRulePostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAccessRequestsMeAccessRuleID201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */
    async postAccessRequestsAppRulePersonID(requestParameters: PostAccessRequestsAppRulePersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAccessRequestsMeAccessRuleID201Response> {
        const response = await this.postAccessRequestsAppRulePersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */
    async postAccessRequestsMeAccessRuleIDRaw(requestParameters: PostAccessRequestsMeAccessRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAccessRequestsMeAccessRuleID201Response>> {
        if (requestParameters.accessRuleId === null || requestParameters.accessRuleId === undefined) {
            throw new runtime.RequiredError('accessRuleId','Required parameter requestParameters.accessRuleId was null or undefined when calling postAccessRequestsMeAccessRuleID.');
        }

        if (requestParameters.accessRequestPostRequest === null || requestParameters.accessRequestPostRequest === undefined) {
            throw new runtime.RequiredError('accessRequestPostRequest','Required parameter requestParameters.accessRequestPostRequest was null or undefined when calling postAccessRequestsMeAccessRuleID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-requests/me/{access_rule_id}`.replace(`{${"access_rule_id"}}`, encodeURIComponent(String(requestParameters.accessRuleId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestPostRequestToJSON(requestParameters.accessRequestPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAccessRequestsMeAccessRuleID201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */
    async postAccessRequestsMeAccessRuleID(requestParameters: PostAccessRequestsMeAccessRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAccessRequestsMeAccessRuleID201Response> {
        const response = await this.postAccessRequestsMeAccessRuleIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
